import React from 'react'
import { sharedData } from '../../../models/shared_data'

import InputMask from 'react-input-mask'
import { superagent } from '../superagent/superagent';
import singletons from '../singletons'
import { MessageComponent } from '../dialog/message.component'

export class FastOrderComponent extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      sent: false,
      params: {
        phone: '',
        name: '',
        title: props.params.header
      }
    }
    this.messageParams = {
      message: 'Спасибо! Скоро с вами свяжется наш менеджер.',
      timeout: 5
    }

    this.makeOrder = this.makeOrder.bind(this)
    this.onCloseMessage = this.onCloseMessage.bind(this)
  }

  onCloseMessage() {
    this.setState({
      sent: false
    })
  }

  changeParams(name, e) {
    e.preventDefault()

    const v = e.target.value
    this.setState((ps)=> {
      ps.params[name] = v
      return ps
    })
  }

  isValidPhone() {
    const phone = this.state.params.phone.replace(/\D/g,'');
    return phone.length >= 10 + ('' + sharedData.data.site_params.phone_start).length
  }

  isFormValidClass() {
    if(this.isValidPhone())
      return ''
    return 'btn--disabled'
  }

  makeOrder(e) {
    e.preventDefault()

    if(this.isFormValidClass() != '')
      return

    singletons['loading'].start()
    superagent.post("/api/fast_order")
      .send(this.state.params)
      .end((err, resp)=> {
        const data = resp.body
        this.setState({
          params: {
            phone: '',
            name: '',
            title: this.props.params.header
          },
          sent: true
        })

        if(this.props.params.js.length > 0) {
          eval(this.props.params.js)
        }

        singletons['loading'].stop()
      })
  }

  render() {
    const prms = this.state.params
    const mask = sharedData.phone_mask

    return (
      <div>
          <div className="order-block">
            <div className="h3 center">{this.props.params.header}</div>
              <div className="input">
                <input className="input__text" name="name"
                  placeholder="Имя" type="text"
                  value={prms.name}
                  onChange={(e)=> { this.changeParams('name', e) }}
                />
              </div>
            <div className="input">
              <InputMask
                className="input__text"
                placeholder="Телефон"
                type="text"
                value={prms.phone}
                onChange={(e)=> { this.changeParams('phone', e) }}
                mask={mask}
              />
            </div>
            <div className="center">
              <button className={
                "btn btn--red " +
                this.isFormValidClass()
              } onClick={this.makeOrder}>Заказать</button>
            </div>
          </div>
          { this.props.params.decoration &&
            <div className="order-block-h2o"></div>
          }
          { this.state.sent &&
            <MessageComponent params={this.messageParams} onClose={this.onCloseMessage}/>
          }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/javascript/website_default/js/react/shared/fast_order/fast_order.component.jsx